import { render, staticRenderFns } from "./Foyer2D.vue?vue&type=template&id=028868e4"
import script from "./Foyer2D.vue?vue&type=script&lang=js"
export * from "./Foyer2D.vue?vue&type=script&lang=js"
import style0 from "./Foyer2D.vue?vue&type=style&index=0&id=028868e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports